/**
 * Операционная система пользователя для экранов набора.
 *
 * Передаётся контекстом, а не пропсом через все экраны: система нужна только
 * там, где показывается или разбирается клавиша, но экранов набора много, и
 * протаскивать её через каждый — это менять десяток сигнатур ради одного
 * значения, которое у всех одно и то же (так же сделан фокус-режим, AD-088).
 *
 * Значение по умолчанию — то же, что и в раскладках: пока пространство не
 * загружено, показывать всё равно нечего.
 */

import { createContext, useContext } from 'react';
import { DEFAULT_PLATFORM, type OsPlatform } from '@type2x/shared-contracts';

export const PlatformContext = createContext<OsPlatform>(DEFAULT_PLATFORM);

/** Операционная система текущего профиля. */
export function usePlatform(): OsPlatform {
  return useContext(PlatformContext);
}
